var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "order-details p-20 pt-0 order-container" }, [
    _c("div", { staticClass: "order-details--top flex-between-end" }, [
      _c("div", { staticClass: "flex-start-center flex-wrap" }, [
        _c("div", { staticClass: "order-details--type my-5 mr-10" }, [
          _vm.order.SaleAreaId == 1
            ? _c("div", { staticClass: "flex-start-start" }, [
                _c("div", { staticClass: "tagIcon-grey1" }, [
                  _c("i", { staticClass: "fie-icon_store" }),
                  _c("span", [_vm._v("Table " + _vm._s(_vm.order.Table))]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.SaleAreaId == 2
            ? _c("div", { staticClass: "flex-start-start" }, [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.SaleAreaId == 3
            ? _c("div", { staticClass: "flex-start-start" }, [_vm._m(1)])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.SaleAreaId == 4
            ? _c("div", { staticClass: "flex-start-start" }, [_vm._m(2)])
            : _vm._e(),
        ]),
        _vm._v(" "),
        !_vm.isTicket
          ? _c(
              "div",
              { staticClass: "d-flex" },
              [
                !(_vm.order.payments && _vm.order.payments.length)
                  ? _c(
                      "div",
                      { staticClass: "order-details-payment my-5 mr-10" },
                      [_vm._m(3)]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.order.payments, function (payment, i) {
                  return _c(
                    "div",
                    { key: i, staticClass: "order-details-payment my-5 mr-10" },
                    [
                      payment.PaymentMethod == 1
                        ? _c("span", { staticClass: "tagIcon-grey1" }, [
                            _c("i", { staticClass: "fie-icon_cash-register" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  (_vm.order.shop.info &&
                                    _vm.order.shop.info.labels.EnCaisse) ||
                                    "En caisse"
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      payment.PaymentMethod == 2
                        ? _c("span", { staticClass: "tagIcon-grey1" }, [
                            _c("i", { staticClass: "fie-icon_credit-card" }),
                            _c("span", [_vm._v("Carte bleue")]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      payment.PaymentMethod == 4
                        ? _c("span", { staticClass: "tagIcon-grey1" }, [
                            _c("i", { staticClass: "fie-icon_discount" }),
                            _c("span", [_vm._v("Fidélité")]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      payment.PaymentMethod == 8
                        ? _c("span", { staticClass: "tagIcon-grey1" }, [
                            _c("i", { staticClass: "fie-icon_ticket" }),
                            _c("span", [_vm._v("PayGreen")]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      payment.PaymentMethod == 16
                        ? _c("span", { staticClass: "tagIcon-grey1" }, [
                            _c("i", { staticClass: "fie-icon_ticket" }),
                            _c("span", [_vm._v("Wallet")]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      payment.PaymentMethod == 32
                        ? _c("span", { staticClass: "tagIcon-grey1" }, [
                            _c("i", { staticClass: "fie-icon_ticket" }),
                            _c("span", [_vm._v("Edenred")]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      ![1, 2, 4, 8, 16, 32].includes(+payment.PaymentMethod)
                        ? _c("span", { staticClass: "tagIcon-grey1" }, [
                            _c("i", { staticClass: "fie-icon_ticket" }),
                            _c("span", [_vm._v("Autres")]),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex-between-center" }, [
      _c("div", { staticClass: "display-3 ml-5 fsize-13" }, [
        _vm._v("Commandé le " + _vm._s(_vm.utcToLocal(_vm.order.OrderDate))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-end gap-5 gap-5" }, [
        _c(
          "button",
          {
            staticClass: "btnIcon-color1",
            attrs: { title: "Imprimer" },
            on: {
              click: function ($event) {
                return _vm.CartService.printCurrentOrder()
              },
            },
          },
          [_c("i", { staticClass: "fa fa-print" })]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btnIcon-color1",
            attrs: { title: "Partager" },
            on: {
              click: function ($event) {
                return _vm.share()
              },
            },
          },
          [_c("i", { staticClass: "fie-icon_share" })]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "order-details-infos shadow-2 p-20 bg-white mt-20 radius-5",
      },
      [
        !_vm.isTicket
          ? _c("InfosShopOrder", { attrs: { order: _vm.order } })
          : _c("InfosShopTicket", { attrs: { order: _vm.order } }),
        _vm._v(" "),
        !_vm.isTicket
          ? _c(
              "ul",
              { staticClass: "order-details-summary mt-30 text-grey2" },
              [
                _c(
                  "li",
                  {
                    staticClass:
                      "order-details-summary-date flex-start-start pb-10",
                  },
                  [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "order-details-summary-details h-100 flex-center-start flex-column",
                      },
                      [
                        _c("div", { staticClass: "fsize-10 text-uppercase" }, [
                          _vm._v("Quand"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "fsize-12 color-1" }, [
                          _vm._v(
                            _vm._s(
                              _vm.extractOrderDay(_vm.order.PickupTimeDate)
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass:
                      "order-details-summary-time flex-start-start pb-10",
                  },
                  [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "order-details-summary-details h-100 flex-center-start flex-column",
                      },
                      [
                        _c("div", { staticClass: "fsize-10 text-uppercase" }, [
                          _vm._v("À quelle heure"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "fsize-12 color-1" }, [
                          _vm._v(
                            _vm._s(
                              _vm.extractOrderTime(_vm.order.PickupTimeDate)
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.order.SaleAreaId != _vm.ShopService.SALE_AREAS.DELIVERY
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-location flex-start-start pb-10",
                      },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-details-summary-details h-100 flex-center-start flex-column",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fsize-10 text-uppercase" },
                              [_vm._v("Où")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "fsize-12 color-1" }, [
                              _vm._v(
                                _vm._s(_vm.order.shop.DefaultName) +
                                  ", " +
                                  _vm._s(_vm.order.shop.Address1) +
                                  "\n                            " +
                                  _vm._s(_vm.order.shop.Address2) +
                                  ", " +
                                  _vm._s(_vm.order.shop.Zip) +
                                  " "
                              ),
                              _c("span", { staticClass: "text-uppercase" }, [
                                _vm._v(_vm._s(_vm.order.shop.City)),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.SaleAreaId == _vm.ShopService.SALE_AREAS.DELIVERY
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-location flex-start-start pb-10",
                      },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-details-summary-details h-100 flex-center-start flex-column",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fsize-10 text-uppercase" },
                              [_vm._v("Livrer à")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "fsize-12 color-1" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.order.address.PlusCode) +
                                  "\n                            " +
                                  _vm._s(_vm.order.address.Company) +
                                  " " +
                                  _vm._s(_vm.order.address.Address) +
                                  ", " +
                                  _vm._s(_vm.order.address.Zip) +
                                  "\n                            "
                              ),
                              _c("span", { staticClass: "text-uppercase" }, [
                                _vm._v(_vm._s(_vm.order.address.City)),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.order.address.Commentaire) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href: `https://www.google.com/maps/@${
                                    _vm.order.address.Location.latitude
                                  },${
                                    _vm.order.address.Location.longitude
                                  },16z?q=${_vm.gmapsQuery(_vm.order.address)}`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Ouvrir avec Google maps\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.Comment
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-comment flex-start-start pb-10",
                      },
                      [
                        _vm._m(8),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-details-summary-details h-100 flex-center-start flex-column",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fsize-10 text-uppercase" },
                              [_vm._v("Commentaire")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fsize-12 color-1",
                                staticStyle: { "word-break": "break-all" },
                              },
                              [_vm._v(_vm._s(_vm.order.Comment))]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.shop.info && _vm.order.shop.info.salon.active
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-comment flex-start-start pb-10",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fsize-12 color-1",
                            staticStyle: { "word-break": "break-all" },
                          },
                          [
                            _c("vue-json-pretty", {
                              attrs: { data: _vm.order.info2 },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.order.stuart_job_id
      ? _c(
          "div",
          {
            staticClass:
              "order-details--stuart collapseBlock shadow-2 p-20 bg-white mt-20 radius-5",
          },
          [
            _c(
              "div",
              {
                staticClass: "flex-between-center cursor-pointer",
                on: {
                  click: function ($event) {
                    _vm.isCollapsed = !_vm.isCollapsed
                    _vm.getJob()
                  },
                },
              },
              [
                _c("div", { staticClass: "flex-start-center" }, [
                  _c("i", { staticClass: "fie-icon_delivery fsize-26 mr-10" }),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "flex-start-center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-bold color-grey1 text-uppercase fsize-16",
                        },
                        [_vm._v("Livraison")]
                      ),
                      _vm._v(" "),
                      !_vm.isCollapsed
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex-center-center pill text-white bg-bo-s2 cursor-pointer mx-5 fsize-14 line-height-1",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.getJob()
                                  _vm.isCollapsed = false
                                },
                              },
                            },
                            [
                              _c("span", [_vm._v("Actualiser")]),
                              _vm._v(" "),
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.stuartProcessing,
                                    expression: "stuartProcessing",
                                  },
                                ],
                                staticClass: "loading ml-5",
                              }),
                              _vm._v(" "),
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.stuartProcessing,
                                    expression: "!stuartProcessing",
                                  },
                                ],
                                staticClass: "fie-icon_reload ml-5",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-bold color-grey2 fsize-10" },
                      [
                        _vm._v(
                          "Livraison prévue à: " +
                            _vm._s(
                              _vm.stuart_job
                                ? _vm
                                    .moment(_vm.stuart_job.dropoff_at)
                                    .format("HH:mm")
                                : ""
                            )
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("collapse-indicator", { attrs: { open: !_vm.isCollapsed } }),
              ],
              1
            ),
            _vm._v(" "),
            _c("collapse-transition", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isCollapsed,
                      expression: "!isCollapsed",
                    },
                  ],
                },
                [
                  _c("stuart-job", { attrs: { job: _vm.stuart_job } }),
                  _vm._v(" "),
                  _vm.order.stuart_status
                    ? _c("div", [
                        _vm.order.stuart_status
                          ? _c("div", { staticClass: "panel-danger" }, [
                              _c("div", { staticClass: "panel-heading" }, [
                                _vm._v(
                                  "\n                                Erreur pour la livraison : " +
                                    _vm._s(_vm.order.stuart_status.message) +
                                    "\n                                "
                                ),
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.order.stuart_status.data,
                                    function (values, k) {
                                      return _c(
                                        "li",
                                        { key: k },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(k) +
                                              ": "
                                          ),
                                          _vm._l(values, function (value, i) {
                                            return _c("div", { key: i }, [
                                              _vm._v(_vm._s(value)),
                                            ])
                                          }),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "order-details--cart collapseBlock shadow-2 p-20 bg-white mt-20 radius-5",
      },
      [
        _c(
          "div",
          { staticClass: "order-cart minicart" },
          [_c("order-items", { attrs: { order: _vm.order } })],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _vm.isTicket
      ? _c(
          "div",
          {
            staticClass:
              "order-details-bottom p-20 mt-20 bg-white radius-5 shadow-3",
          },
          [_c("TicketTvas", { attrs: { order: _vm.order } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "order-details-bottom p-20 mt-20 bg-white radius-5 shadow-3",
      },
      [
        _c("order-summary-mini", {
          attrs: { order: _vm.order, isTicket: _vm.isTicket },
        }),
        _vm._v(" "),
        _vm.showReorder
          ? _c(
              "button",
              {
                staticClass: "btnFlat-color2 shadow-1 w-100 mt-20",
                on: {
                  click: function ($event) {
                    return _vm.CartService.reorder(_vm.order)
                  },
                },
              },
              [_vm._v("\n                Commander à nouveau\n            ")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isTicket
      ? _c(
          "div",
          {
            staticClass:
              "order-details-bottom p-20 mt-20 bg-white radius-5 shadow-3",
          },
          [
            _c("legalInfo", {
              attrs: { order: _vm.order, isTicket: _vm.isTicket },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "p-20 mt-20 bg-white radius-5 shadow-3" },
      [
        _c("StarRating", {
          attrs: { order: _vm.order, "is-ticket": _vm.isTicket },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tagIcon-grey1" }, [
      _c("i", { staticClass: "fie-icon_on-site" }),
      _c("span", [_vm._v("Sur place")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tagIcon-grey1" }, [
      _c("i", { staticClass: "fie-icon_takeaway" }),
      _c("span", [_vm._v("A emporter")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tagIcon-grey1" }, [
      _c("i", { staticClass: "fie-icon_delivery" }),
      _c("span", [_vm._v("Livraison")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tagIcon-bo-p1" }, [
      _c("i", { staticClass: "fie-icon_error" }),
      _c("span", [_vm._v("Erreur paiement")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_calendar" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_time" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_pin" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_delivery" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_help" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }